import * as Immutable from 'immutable';
import moment from 'moment';

class LogEntry extends React.Component {
  renderFields() {

    let hasVisibleFields = false

    if (this.props.action === 'I') {
      const logEntryRow = (
        <div className='updated-fields'>
          {
            this.props.rowData.map((value, key) => {
              // only showing visible fields if provided
              if(Array.isArray(this.props.visibleFields) && !this.props.visibleFields?.includes(key)) {
                return null
              }
              hasVisibleFields = true

              return (
                <div key={key} className='field'>
                  <span className='key'>{key}</span>:&nbsp;
                  <span className='value'>{value}</span>
                  <span className='business-name'>{
                    key === 'business_uuid'
                    && this.props.businessName}
                  </span>
                </div>
              );
            }).valueSeq()
          }
        </div>
      );
      return hasVisibleFields ? logEntryRow : null
    }

    const logEntryRow = (
      <div className='updated-fields'>
        {
          this.props.changedFields?.map((value, key) => {
            // only showing visible fields if provided
            if(Array.isArray(this.props.visibleFields) && !this.props.visibleFields?.includes(key)) {
              return null
            }
            hasVisibleFields = true

            return (
              <div key={key} className='field'>
                <span className='key'>{key}</span>:&nbsp;
                <span className='old-value'>{this.props.rowData.get(key)}</span>
                &nbsp;&rarr;&nbsp;
                <span className='value'>{value}</span>
                <span className='business-name'>{
                  this.props.changedFields.get('business_uuid')
                    && key === 'business_uuid'
                    && this.props.businessName}
                </span>
              </div>
            );
          }).valueSeq()
        }
      </div>
    );
    return hasVisibleFields ? logEntryRow : null
  }

  renderUpdatedBy() {
    const updatedByUUID = this.props.updatedBy.get('uuid')

    if (!updatedByUUID) {
      return (
        <></>
      );
    }

    if (updatedByUUID === 'system-performed-action') {
      return (
        <div>Yoco System</div>
      );
    }

    // If we don't have user first/last names for whatever reason, just display 'User' as a hyperlink
    // to the user's details page
    const updatedByFirstName = this.props.updatedBy.get('firstName', "User")
    const updatedByLastName = this.props.updatedBy.get('lastName', "")
    return (
      <a href={`/users/${updatedByUUID}`}>
        { updatedByFirstName } { updatedByLastName }
      </a>
    );
  }

  render() {
    const renderedFields = this.renderFields()
    return renderedFields ? (
      <div className='log-entry'>
        <div className='timestamp'>
          { moment(this.props.timestamp).format('YYYY/MM/DD HH:mm:ss') }
        </div>
        <div className='updated-by'>
          { this.renderUpdatedBy() }
        </div>
        { this.renderFields() }
      </div>
    ): null;
  }
}

class AuditLog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    if (this.props.loadOnMount) {
      this.load();
    }
  }

  onLoadClick() {
    this.load();
  }

  isUpdatedByUserMissingDetails(updatedByUser) {
    const updatedByUuid = updatedByUser.uuid
    return updatedByUuid &&
        updatedByUuid !== "system-performed-action" &&
        !updatedByUser.firstName &&
        !updatedByUser.lastName
  }

  patchMissingUserDetailsInAuditLogs(auditLogs, updatedByUsersToPatch) {
    // Fetch user details in batches of 5 uuids (this is to prevent potential issues with url max length)
    const userUUIDs = Object.keys(updatedByUsersToPatch)
    const batchSize = 5;
    for (let i = 0; i < userUUIDs.length; i += batchSize) {
      const uuidsToFetch = userUUIDs.slice(i, i + batchSize);
      const requestFilters = {
        uuid: uuidsToFetch
      }

      $.ajax({
        url: `/api/users/?display=simple&filters=${encodeURIComponent(JSON.stringify(requestFilters))}`,
        dataType: 'json',
        type: 'GET'
      }).done((response) => {
        if (response.status === 200) {
          response.data.users.forEach(user => {
            const updatedByUsersForUUID = updatedByUsersToPatch[user.uuid]
            updatedByUsersForUUID.forEach(updatedByUser => {
              updatedByUser.firstName = user.firstName
              updatedByUser.lastName = user.lastName
            })
          })

          this.setState({
            auditLogs: Immutable.fromJS(auditLogs)
          });
        } else {
          this.setState({
            errorCode: response.status,
            errorMessage: response.message
          });
        }
      }).fail((unused, textStatus) => {
        this.setState({
          errorMessage: textStatus
        });
      });
    }
  }

  setAuditLogs(auditLogs) {
    this.setState({
      auditLogs: Immutable.fromJS(auditLogs)
    });

    // Check for any updated by users in the audit logs that are missing user details (first & last names). This is
    // to cater for audit logs from services other than Core, that don't maintain all user details, but just have
    // user UUIDs.
    // There could be multiple audit log entries for the same user, so we track each user's audit objects
    // in a list, keyed by the user's uuid.
    let updatedByUsersToPatch = {}
    auditLogs.forEach(auditLog => {
      const updatedByUser = auditLog.updatedBy
      const updatedByUUID = updatedByUser.uuid
      if (this.isUpdatedByUserMissingDetails(updatedByUser)) {
        const updatedByUsersForUUID = updatedByUUID in updatedByUsersToPatch ? updatedByUsersToPatch[updatedByUUID] : updatedByUsersToPatch[updatedByUUID] = []
        updatedByUsersForUUID.push(updatedByUser)
      }
    })

    // If any audit entries contain updated by users with missing details, fetch basic details for these users
    // and patch the audit log entries.
    if (!!Object.keys(updatedByUsersToPatch).length) {
      this.patchMissingUserDetailsInAuditLogs(auditLogs, updatedByUsersToPatch)
    }
  }

  load() {
    if (this.props.uuid) {
      $.ajax({
        url: `${this.props.api}${this.props.uuid}${this.props.excludeTrailingSlash ? '' : '/'}`,
        dataType: 'json',
        type: 'GET'
      }).done((response) => {
        if (response.status === 200) {
          this.setAuditLogs(response.data.auditLogs)
        } else {
          this.setState({
            errorCode: response.status,
            errorMessage: response.message
          });
        }
      }).fail((unused, textStatus) => {
        this.setState({
          errorMessage: textStatus
        });
      });
    }
  }

  render() {
    let inner = (
      <button
        type='button'
        className='btn ladda-button btn-primary'
        data-spinner-size='32'
        data-style='zoom-out'
        onClick={this.onLoadClick.bind(this)}
      >
        { this.props.loadButtonLabel }
      </button>
    );

    if (this.state.auditLogs) {
      inner = (
        <div className='audit-logs'>
          {
            this.state.auditLogs.map((logEntry) => {
              return <LogEntry key={logEntry.get('id')} {...logEntry.toObject()} />;
            })
          }
        </div>
      );
    } else if (this.state.errorMessage) {
      inner = (
        <div className='error'>{this.state.errorMessage}</div>
      );
    }

    return (
      <div>
        <header>
          <h1>{ this.props.title }</h1>
        </header>

        { inner }
      </div>
    );
  }
}

class CardReaderAuditLog extends AuditLog {
  fetch(url) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url,
        dataType: 'json',
        type: 'GET'
      }).done((response) => {
        if (response.status === 200) {
          resolve(Immutable.fromJS(response.data.auditLogs))
        } else {
          this.setState({
            errorCode: response.status,
            errorMessage: response.message
          });
          reject()
        }
      }).fail((unused, textStatus) => {
        this.setState({
          errorMessage: textStatus
        });
        reject()
      });
    })
  }

  setAuditLogs(auditLogs) {
    this.setState({
      auditLogs: this.state.auditLogs ?
          this.state.auditLogs.push(...auditLogs)
              .sort((a, b) => {
                return a.get("timestamp") > b.get("timestamp") ? -1:1 ;
              })
          : auditLogs
    });
  }
  load() {
    if (this.props.uuid) {
      this.fetch(`/api/auditLogs/${this.props.uuid}/`).then((auditLogs) => {
        this.setAuditLogs(auditLogs)
      })
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get("readerServiceId")) {
      this.fetch(`/api/readerServiceAuditLogs/${searchParams.get("readerServiceId")}/`).then((auditLogs) => {
        const readerServiceAuditLogFields = auditLogs.map(auditLog=>
            auditLog.set("visibleFields",
              ["fulfilment_id", "allocation_type", "source"]
            ))
        this.setAuditLogs(Immutable.fromJS(readerServiceAuditLogFields))
      })
    }
  }
}


AuditLog.defaultProps = {
  loadButtonLabel: 'Load object history',
  title: 'Object history'
};

module.exports = {
  AuditLog,
  CardReaderAuditLog
};
